export default __webpack_public_path__ + "static/media/Cookie_policy.7a43bca9.pdf";